<template>
  <div class="container">
    <p>When you are close, a sign shall be given.</p>
    <div style="height: calc(clamp(2rem, 17.6vmin, 4.5rem) * 0.3)">
      <ProgressIndicator :progress="progress" />
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import ProgressIndicator from '@/components/ProgressIndicator.vue'

export default {
  name: 'Tutorial3',
  components: { ProgressIndicator },
  data() {
    return {
      progress: 0,
    }
  },
  mounted() {
    const tl = gsap.timeline({ repeat: -1, yoyo: false })
    tl.fromTo(
      this,
      { progress: 0 },
      { progress: 0, duration: 0.5, ease: 'linear' }
    )
    tl.fromTo(
      this,
      { progress: 0 },
      { progress: 100, duration: 1.5, ease: 'linear' }
    )
    tl.fromTo(
      this,
      { progress: 100 },
      { progress: 100, duration: 0.7, ease: 'linear' }
    )
    tl.play()
  },
}
</script>

<style scoped>
.container {
  height: 100%;
  width: 100%;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
}

p {
  margin-bottom: 2em;
}
</style>
